import React from 'react';
import { Path, Rect, Svg } from 'react-native-svg';

export interface ChevronLeftBadgeIconProps {
    size?: number;
    disabled?: boolean;
    arrowColor?: string;
    bgColor?: string;
}

export const ChevronLeftBadgeIcon: React.FC<ChevronLeftBadgeIconProps> = ({
    size = 20,
    disabled = false,
    arrowColor,
    bgColor,
}) => {
    const finalBg = bgColor ?? '#EEE';
    const finalArrow = arrowColor ?? (disabled ? '#999' : '#333');
    return (
        <Svg width={size} height={size} viewBox="0 0 20 20" fill="none">
            <Rect width={20} height={20} fill={finalBg} rx={10} />
            <Path
                fill={finalArrow}
                d="M10.813 13.75 7.063 10l3.75-3.75.875.875L8.813 10l2.875 2.875-.875.875"
            />
        </Svg>
    );
};

export default ChevronLeftBadgeIcon;
